// extracted by mini-css-extract-plugin
export default {"form":"ObjectContactsForm_form__rkygH","title":"ObjectContactsForm_title__1uGhW"};